import React, { useEffect } from 'react';
import { Form, Input, message, Modal } from 'antd';
import { createPromptTemplate, getPromptTemplateDetail, updatePromptTemplate, PromptTemplateVo } from '@/api/prompt';

export interface EditTemplateProp {
  data?: PromptTemplateVo;
  isEdit?: boolean;
  updateFn: () => void;
  onCancel: () => void;
}

const EditTemplate = ({ data, isEdit, updateFn, onCancel }: EditTemplateProp) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (isEdit && data?.id) {
      setLoading(true);
      getPromptTemplateDetail(data.id)
        .then(res => form.setFieldsValue(res))
        .finally(() => setLoading(false));
    }
  }, [data?.id, isEdit, form]);

  const onFinish = () => {
    form.validateFields().then(values => {
      const params = { ...values, id: isEdit ? data?.id : undefined };
      const api = isEdit ? updatePromptTemplate : createPromptTemplate;
      api(params as any).then(() => {
        message.success('保存成功');
        onCancel();
        updateFn();
      });
    });
  };

  return (
    <Modal
      title={isEdit ? '编辑模板' : '新增模板'}
      open={true}
      onCancel={onCancel}
      onOk={onFinish}
      maskClosable={false}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="name" label="模板名称" rules={[{ required: true, message: '请输入模板名称' }]}>
          <Input placeholder="请输入模板名称" />
        </Form.Item>
        <Form.Item name="description" label="模板描述">
          <Input.TextArea rows={3} placeholder="请输入模板描述" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditTemplate;